// extracted by mini-css-extract-plugin
export default {"buttonStyle":"slider_buttonStyle__oaRYH","imageSlider":"slider_imageSlider__iRSZk"};